import { render, staticRenderFns } from "./ConceptoNominaTabs.vue?vue&type=template&id=c560056c&scoped=true"
import script from "./ConceptoNominaTabs.vue?vue&type=script&lang=js"
export * from "./ConceptoNominaTabs.vue?vue&type=script&lang=js"
import style0 from "./ConceptoNominaTabs.vue?vue&type=style&index=0&id=c560056c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c560056c",
  null
  
)

export default component.exports